<div id="main" class="row main">
    <div *ngIf="!loading && this.banners.length>0" class="col-12 banner">
        <app-slider [images]="this.banners"></app-slider>
    </div>
    <div class="col-10 offset-1 ">
        <h4>Search for Dealership Name, Address, Region, Contact Number etc.</h4>
        <div class="row searchrow">
            <form [formGroup]="searchForm">
                <input class="col-12 search" formControlName="search" (focus)="searchfocus(true)"
                    (blur)="searchfocus(false)" type="text" placeholder="Search..">
                <ul class="col-12" *ngIf="searchShowing">


                    <li *ngIf="this.Dealers.length > 0 && filteredDealerships().length > 0">
                        <h5>Dealership</h5>
                        <p *ngFor="let dealer of filteredDealerships()"><a
                                href="/dealership/{{dealer.DealershipID_PK}}">{{dealer.Name}}</a></p><br>
                    </li>
                </ul>
            </form>
        </div>
        <div class="row">
            <div class="col-lg-3 col-md-4 item" *ngFor="let d of Dealers">
                <a href="/dealership/{{d.DealershipID_PK}}">
                    <div class="card">
                        <div class="imgcontainer">
                        <img loading="lazy" class="card-img-top" *ngIf="d.Image !== null" src="{{d.Image}}" alt="{{d.Name}} image">
                        <img loading="lazy" class="card-img-top" *ngIf="d.Image == null" src="{{currentSite.vehicleImages.Value}}" alt="Fallback site image">
                        </div>
                        <div class="card-body">
                            <div class="row">
                                <h6>{{d.Name}}</h6>
                                <div class="col">
                                    <div class="dealerdetails">
                                        <a href="tel:{{d.PhoneNumber}}">
                                            <p>Tel: {{d.PhoneNumber}}</p>
                                        </a>
                                        <p>{{d.AddressPhysicalStreet}}</p>
                                        <p>{{d.AddressPhysicalCity}}</p>
                                    </div>
                                </div>
                                <div *ngIf="d.WhatsAppNumber" class="col-3">
                                    <div class=" WA-Icon">
                                    <a href="https://api.whatsapp.com/send?phone={{d.WhatsAppNumber.replace('+','')}}&text=Hello, I saw something on your website" target="_blank">
                                        <svg id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64.87 64.87">
                                            <defs><style>.cls-1 {fill: #fff;fill-rule: evenodd;}.cls-2 {fill: #25d366;}</style></defs>
                                            <g id="OBJECTS"><g><circle class="cls-2" cx="32.44" cy="32.44" r="32.44"/><g>
                                                <path class="cls-1" d="M53.71,31.36c-.28-11.21-9.52-20.21-20.89-20.21S12.43,19.94,11.94,30.98c0,.3-.02.61-.02.91,0,3.92,1.1,7.58,2.99,10.71l-3.77,11.12,11.57-3.68c2.99,1.64,6.44,2.58,10.1,2.58,11.55,0,20.9-9.29,20.9-20.74,0-.18,0-.35,0-.53ZM32.82,49.32c-3.57,0-6.89-1.06-9.67-2.89l-6.75,2.15,2.19-6.48c-2.1-2.88-3.35-6.41-3.35-10.22,0-.57.03-1.13.09-1.69.86-8.83,8.38-15.74,17.48-15.74s16.81,7.09,17.51,16.08c.04.45.06.9.06,1.36,0,9.62-7.89,17.44-17.57,17.44Z"/>
                                                <path class="cls-1" d="M42.4,36.08c-.52-.25-3.03-1.49-3.5-1.65-.47-.18-.81-.25-1.15.25-.34.51-1.33,1.65-1.62,1.99-.3.34-.6.38-1.11.13-.51-.25-2.16-.78-4.12-2.52-1.52-1.34-2.55-3-2.85-3.51-.29-.51-.03-.78.23-1.04.23-.23.51-.6.77-.89.07-.09.13-.17.19-.24.12-.19.21-.36.32-.61.18-.34.09-.64-.04-.89-.13-.25-1.15-2.76-1.59-3.78-.42-1.02-.85-.84-1.15-.84s-.64-.05-.98-.05-.9.13-1.37.64c-.47.51-1.79,1.74-1.79,4.25,0,.59.11,1.17.26,1.73.52,1.79,1.63,3.27,1.83,3.52.25.33,3.54,5.64,8.75,7.68,5.21,2.03,5.21,1.35,6.15,1.26.94-.08,3.03-1.22,3.45-2.42.43-1.18.43-2.2.3-2.42-.13-.21-.47-.33-.98-.59Z"/>
                                            </g></g></g>
                                        </svg>
                                    </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card-footer">
                            <app-reviews [reviewnumber]="d.GoogleRatingReviews"
                                [reviewscore]="d.GoogleRatingScore"></app-reviews>
                            

                                    <a *ngIf="d.ServiceOnlineLink" target="_blank" href="{{d.ServiceOnlineLink}}"><button class="btn-primary">Book a
                                        Service Online</button></a>
                                <a *ngIf="!d.ServiceOnlineLink" href="/service?dealership={{d.DealershipID_PK}}"><button class="btn-primary">Book a
                                        Service Online</button></a>

                        </div>
                    </div>
                </a>
            </div>
        </div>
    </div>
</div>